import Vue from 'vue';
import VueAxios from 'vue-axios';
import axios from 'axios';
import ECharts from "vue-echarts";
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import vuelidate from './plugins/vuelidate';
import DateRangePicker from 'vue2-daterange-picker';
// import ECharts modules manually to reduce bundle size
import 'echarts'

// If you want to use ECharts extensions, just import the extension package, and it will work
// Taking ECharts-GL as an example:
// You only need to install the package with `npm install --save echarts-gl` and import it as follows
// import 'echarts-gl'

// register component to use
Vue.component('e-chart', ECharts)
Vue.use(DateRangePicker);
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);

new Vue({
  router,
  store,
  vuetify,
  vuelidate: vuelidate(),
  render: (h) => h(App),
}).$mount('#app');
